<figure>
  <button type="button" class="lightbox-trigger" (click)="open()">
    <div class="variable-size-image" [style.aspect-ratio]="aspectRatio()">
      <img
        [ngSrc]="src()"
        fill
        [priority]="priority()"
        [sizes]="sizes()"
        [alt]="alt()"
        [class.fit-cover]="fit() === 'cover'"
        [class.fit-contain]="fit() === 'contain'"
      />
    </div>
  </button>
  @if (caption()) {
    <figcaption>{{ caption() }}</figcaption>
  }
</figure>

<!-- (click) is backdrop-dismiss (event.target === dialog itself, since the
     <img> is the only other content). Escape already closes natively via
     <dialog>, but (keydown.escape) makes that explicit so the element has
     its own keyboard-triggered close mirroring the click, and tabindex="-1"
     makes it a valid (non-Tab-order) focus target — together these satisfy
     click-events-have-key-events + interactive-supports-focus for real,
     rather than suppressing them. -->
<dialog
  #dialog
  grooveDialog
  tabindex="-1"
  (click)="close()"
  (keydown.escape)="close()"
>
  <img [src]="src()" [alt]="alt()" loading="lazy" />
</dialog>
